/* Daily Dons — reviews.js
   Write-a-review reveal, star picker with hover labels, histogram fill
   animation, and Ajax submit of the native contact form so the thank-you
   state shows in place (degrades to a normal POST without JS). */
(function () {
  'use strict';

  function init(section) {
    var toggle = section.querySelector('[data-rev-toggle]');
    var wrap = section.querySelector('[data-rev-form-wrap]');
    var form = section.querySelector('[data-rev-form]');
    var picker = section.querySelector('[data-rev-picker]');
    var ratingInput = section.querySelector('[data-rev-rating]');
    var submitBtn = section.querySelector('[data-rev-submit]');

    /* Toggle form */
    if (toggle && wrap) {
      toggle.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        toggle.textContent = open ? toggle.getAttribute('data-label-cancel') : toggle.getAttribute('data-label-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    /* Star picker */
    if (picker && ratingInput) {
      var stars = [].slice.call(picker.querySelectorAll('[data-rev-star]'));
      var label = picker.querySelector('[data-rev-picker-label]');
      var labels = ['', 'Poor', 'Fair', 'Good', 'Great', 'Excellent'];
      var value = 0, hover = 0;

      function paint() {
        var shown = hover || value;
        stars.forEach(function (s, i) {
          var lit = i < shown;
          s.classList.toggle('is-lit', lit);
          s.querySelector('path').setAttribute('fill', lit ? 'var(--dd-reseda-green)' : '#dcdccb');
        });
        if (label) {
          label.textContent = labels[shown] || ' ';
          label.classList.toggle('is-visible', shown > 0);
        }
        validate();
      }
      stars.forEach(function (s, i) {
        s.addEventListener('mouseenter', function () { hover = i + 1; paint(); });
        s.addEventListener('click', function () {
          value = i + 1;
          ratingInput.value = String(value);
          stars.forEach(function (b, j) { b.setAttribute('aria-pressed', String(j === i)); });
          paint();
        });
      });
      picker.addEventListener('mouseleave', function () { hover = 0; paint(); });
    }

    function validate() {
      if (!submitBtn || !form) return;
      var ok = form.checkValidity && form.checkValidity() && ratingInput && ratingInput.value !== '';
      submitBtn.disabled = !ok;
    }
    if (form) {
      form.addEventListener('input', validate);
      validate();
    }

    /* Ajax submit → success state */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = section.querySelector('[data-rev-error]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-busy-label'); }
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
          .then(function (res) {
            if (!res.ok) throw new Error('bad status');
            section.querySelector('[data-rev-form-body]').hidden = true;
            section.querySelector('[data-rev-success]').hidden = false;
          })
          .catch(function () {
            if (err) err.hidden = false;
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.getAttribute('data-label'); }
          });
      });
    }

    /* Histogram fill on scroll into view */
    var bars = [].slice.call(section.querySelectorAll('[data-rev-bar]'));
    if (bars.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          bars.forEach(function (b) { b.style.width = b.getAttribute('data-rev-bar') + '%'; });
          io.disconnect();
        }
      }, { rootMargin: '0px 0px -10% 0px' });
      io.observe(section);
    } else {
      bars.forEach(function (b) { b.style.width = b.getAttribute('data-rev-bar') + '%'; });
    }
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-reviews-section]:not([data-rev-init])')
      .forEach(function (el) { el.setAttribute('data-rev-init', '1'); init(el); });
  }
  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
